import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface PrePaymentModalBodyColumnProps {
  flex: number
}

export const PrePaymentModalBodyContainer = styled.div`
  display: flex;
  gap: ${Spacing.S24};
  width: 100%;
`

export const PrePaymentModalBodyColumn = styled.div<PrePaymentModalBodyColumnProps>`
  flex: ${({ flex }) => flex};
`
